/**
 * Utility functions for route persistence to maintain page state on refresh
 */

/**
 * Saves the current route to session storage to persist it across page refreshes
 * @param {string} path - The current path
 */
export const saveCurrentRoute = (path) => {
  if (path) {
    sessionStorage.setItem("lastRoute", path);
  }
};

/**
 * Gets the last route from session storage
 * @returns {string|null} - The last saved route or null if none exists
 */
export const getLastRoute = () => {
  return sessionStorage.getItem("lastRoute");
};

/**
 * Clears the saved route from session storage
 */
export const clearSavedRoute = () => {
  sessionStorage.removeItem("lastRoute");
};

/**
 * Determines if the app should redirect to the saved route
 * @param {string} currentPath - The current path
 * @returns {boolean} - Whether to redirect
 */
export const shouldRedirectToSavedRoute = (currentPath) => {
  const lastRoute = getLastRoute();
  const authPaths = [
    "/signin",
    "/signup",
    "/onboarding",
    "/email-verification",
    "/forgot-password",
    "/reset-password",
  ];

  // Don't redirect if:
  // 1. There is no saved route
  // 2. We're already on the last route
  // 3. We're on an auth page (which requires special handling)
  // 4. The saved route is the feed path and we're on the root path (they're equivalent now)
  if (
    !lastRoute ||
    lastRoute === currentPath ||
    authPaths.includes(currentPath) ||
    currentPath.startsWith("/reset-password/") ||
    (lastRoute === "/feed" && currentPath === "/") ||
    (lastRoute === "/" && currentPath === "/feed")
  ) {
    return false;
  }

  return true;
};

// Route persistence helpers for maintaining navigation state across sessions
